import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { ImageUtilService } from '../../shared/image-util-service/image-util.service';
import { OeAppPersonService } from '../../shared/oe-app-person.service';
import { MODAL_DATA } from '../../shared/tokens/modal-data.token';
import { TeacherFeedbackDto } from '../teacher-feedback-service/teacher-feedback-dto';
import { forkJoin, of, Subscription } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { formatTeacherResponseText } from '../../shared/utils/text-utils';

export interface AskATeacherFeedbackModalData {
  feedback: TeacherFeedbackDto;
}

const AVATAR_SIZE = 42;
const DEFAULT_PROFILE_PIC = '/images/profile-default-image-42x42.png';

@Component({
  selector: 'lp2-ask-a-teacher-feedback-modal',
  templateUrl: './ask-a-teacher-feedback-modal.component.html',
  styleUrls: ['./ask-a-teacher-feedback-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AskATeacherFeedbackModalComponent implements OnInit, OnDestroy {
  public studentAvatarImg: string = '';
  public teacherAvatarImg: string = '';
  public isLoading = false;
  public feedback: TeacherFeedbackDto;
  public studentName: string = null;

  private subscription: Subscription;

  constructor(
    private imageUtilService: ImageUtilService,
    private readonly oeAppPersonService: OeAppPersonService,
    @Inject(MODAL_DATA) public readonly data: AskATeacherFeedbackModalData,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.feedback = this.data.feedback;
    this.feedback.response.text = formatTeacherResponseText(this.feedback.response.text);

    this.studentName = this.oeAppPersonService.getPersonData().displayName;
    this.setAvatars();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private setAvatars(): void {
    this.isLoading = true;
    this.cdRef.detectChanges();

    const studentUuid = this.feedback.studentUuid;
    const teacherUuid = this.feedback.response.teacherUuid;

    const studentAvatar$ = studentUuid
      ? this.imageUtilService.getProfilePicByUuid(AVATAR_SIZE, AVATAR_SIZE, studentUuid)
          .pipe(catchError(() => of(DEFAULT_PROFILE_PIC)))
      : of(DEFAULT_PROFILE_PIC);

    const teacherAvatar$ = teacherUuid
      ? this.imageUtilService.getProfilePicByUuid(AVATAR_SIZE, AVATAR_SIZE, teacherUuid)
          .pipe(catchError(() => of(DEFAULT_PROFILE_PIC)))
      : of(DEFAULT_PROFILE_PIC);

    this.subscription = forkJoin([studentAvatar$, teacherAvatar$]).subscribe(
      ([studentImg, teacherImg]) => {
        this.studentAvatarImg = studentImg || DEFAULT_PROFILE_PIC;
        this.teacherAvatarImg = teacherImg || DEFAULT_PROFILE_PIC;
        this.isLoading = false;
        this.cdRef.detectChanges();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/ask-a-teacher-feedback-modal/ask-a-teacher-feedback-modal.component.ts